import installHR from 'rer-theme/config/Slate/HR';
export default function applyRERSlateConfig(config) {
  config = installHR(config);

  //backport of https://github.com/RedTurtle/design-comuni-plone-theme/commit/9cf846d864f6c28ee550c80f3b1f98d45839e8bf
  config.settings.slate.elements.blockquote = ({
    children,
    attributes,
    ...otherProps
  }) => {
    return (
      <blockquote {...attributes}>
        <p>{children}</p>
      </blockquote>
    );
  };
  return config;
}
